import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-center",
  "use": "svg-center-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"svg-center\"><polyline points=\"2 8 2 2 8 2\" /><polyline points=\"16 2 22 2 22 8\" /><polyline points=\"2 16 2 22 8 22\" /><polyline points=\"16 22 22 22 22 16\" /><polyline points=\"12 6.5 12 9.5\" /><polyline points=\"6.5 12 9.5 12\" /><polyline points=\"14.5 12 17.5 12\" /><polyline points=\"12 14.5 12 17.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol